<div class="card">
    <div class="card-header">
        <h4>{{ _i18n._11057_SELECTION_RESULT | translate }}</h4>
    </div>
    <div class="card-body d-flex flex-column">
        <section>
            <p>{{ _i18n._11058_SELECTED_METRIC | translate }}</p>
            <div class="d-flex align-items-center">
                <h5 class="text-primary m-0">
                    {{ activeMetric?.name ?? '' }}
                </h5>
                <button
                    class="cmps-icon-button--no-bg cmps-icon-button--sm"
                    cmpsIconButton
                    (click)="editSelectedMetric.emit()"
                >
                    <cmps-icon
                        class="cmps-cdk-fill-blue-100"
                        svgIcon="pencil"
                    ></cmps-icon>
                </button>
            </div>
        </section>
        <section>
            <p>{{ _i18n._11059_SELECTED_FOCUS | translate }}</p>
            <div class="selected-focus-card card border p-1">
                <div
                    class="alert alert-primary bg-primary text-white border-0 m-0"
                >
                    <strong
                        >{{ _i18n._11060_BEHAVIOUR | translate }}
                        <br />
                        <span class="font-14">{{
                            selectedFocus?.behaviour?.name ?? ''
                        }}</span>
                    </strong>
                </div>
                <div
                    class="alert alert-primary bg-transparent text-primary m-0"
                >
                    <strong
                        >{{ _i18n._11061_TACTICS | translate }}
                        <br />
                        <span class="font-14">{{
                            selectedFocus?.subBehaviour?.name ?? ''
                        }}</span>
                    </strong>
                </div>
            </div>
        </section>
        <section>
            <p>{{ _i18n._11062_LOADED_GOALS | translate }}</p>
            <div>
                <div
                    *ngFor="let loadedGoal of selectedGoals"
                    class="loaded-goal"
                >
                    <button
                        class="goal-name"
                        (click)="scrollToGoal.emit(loadedGoal.metricId)"
                    >
                        <h5>{{ loadedGoal.metric }}</h5>
                    </button>
                    <button
                        class="cmps-icon-button--no-bg cmps-icon-button--sm"
                        cmpsIconButton
                        (click)="deselectLoadedGoal.emit(loadedGoal.metricId)"
                    >
                        <cmps-icon svgIcon="trash-can-outline"></cmps-icon>
                    </button>
                </div>
            </div>
        </section>
        <section class="flex-grow-1 d-flex flex-column justify-content-end">
            <button
                cmpsButton
                [disabled]="_isDisabled"
                (click)="confirmSelection.emit()"
            >
                <span cmpsButtonLabel>{{
                    _i18n._11063_CONFIRM_SELECTION | translate
                }}</span>
            </button>
        </section>
    </div>
</div>
